"use client";

import { useState } from "react";
import {useRouter  } from "@/navigation";
import { SearchIcon, Loader2 } from "lucide-react";
import { useTranslations } from "next-intl";

export const SearchBar = ({ channel }: { channel: string }) => {
	const router = useRouter();
	const [isLoading, setIsLoading] = useState(false);
	const t = useTranslations('plsyy');
	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const formData = new FormData(e.currentTarget);
		const search = formData.get("search") as string;
		
		if (search && search.trim().length > 0) {
			setIsLoading(true);
			router.push(`/search?query=${encodeURIComponent(search)}`);
		}
	};

	return (
		<div className="overflow-hidden border border-gray-200 bg-white shadow-md mb-4">
			<div className="bg-mainColor px-5 py-3">
				<h2 className="text-lg font-bold text-white flex items-center gap-2">
					<i className="ri-search-line text-lg"></i>
					{t("search")}
				</h2>
			</div>
			<div className="p-5">
				<form
					onSubmit={handleSubmit}
					className="group relative w-full"
				>
					<label className="w-full">
						<span className="sr-only">{t("searchForProducts")}</span>
						<input
							type="text"
							name="search"
							placeholder={t("searchForProducts")}
							autoComplete="on"
							required
							disabled={isLoading}
							className="py-2 px-4 pr-12 w-full h-12 border border-gray-200 bg-white rounded-lg focus:border-mainColor focus:ring-1 focus:ring-mainColor outline-none transition-all duration-200"
						/>
					</label>
					<div className="absolute inset-y-0 right-0 flex items-center pr-4">
						<button
							type="submit"
							disabled={isLoading}
							className="text-gray-400 hover:text-mainColor duration-300 cursor-pointer"
						>
							<span className="sr-only">{t("search")}</span>
							{isLoading ? (
								<Loader2 className="h-5 w-5 animate-spin" />
							) : (
								<SearchIcon aria-hidden className="h-5 w-5" />
							)}
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};
